<template>
  <div>
    <component style="display: none" :is="show_document"></component>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">

                <strong>{{ $t('components.accountingGroups') }}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton @click="addGroupModal = true" size="sm" color="primary">
                  <CIcon name="cil-check-circle"/>
                  {{ $t('buttons.addAccountingGroup') }}
                </CButton>

              </CCol>
            </CRow>

          </CCardHeader>
          <CCardBody>

            <TreeTable2
                ref="table"
                sum-text="sum"
                index-text="#"
                :data="data2"
                max-height="10"
                :columns="columns"
                :stripe="props.stripe"
                :border="props.border"
                :show-header="props.showHeader"
                :show-summary="props.showSummary"
                :show-row-hover="props.showRowHover"
                :show-index="props.showIndex"
                :tree-type="props.treeType"
                :is-fold="props.isFold"
                :expand-type="props.expandType"
                :selection-type="props.selectionType">
              <!--              <template slot="$expand" scope="scope">-->
              <!--                {{ `My name is ${scope.row.name},-->
              <!--           this rowIndex is ${scope.rowIndex}.`-->
              <!--                }}-->
              <!--              </template>-->

              <template slot="name2" scope="scope2">
                {{ scope2.row.name + " (" + scope2.row.code + ")" }}

              </template>

              <template slot="operation" scope="scope">
                <CButton
                    class="m-1"
                    color="primary"
                    variant="outline"
                    square
                    :title="$t('buttons.addSubGroup')"
                    size="sm"
                    @click="add_sub_row(scope.row)"
                >
                  <CIcon name="cil-plus"/>
                </CButton>
                <CButton
                    class="m-1"
                    color="primary"
                    variant="outline"
                    square
                    size="sm"
                    :title="$t('buttons.DetailedGroups')"
                    @click="go_to_detailed(scope.row)"
                >
                  <CIcon name="cil-applications"/>
                </CButton>
              </template>

            </TreeTable2>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>

    </CRow>

    <CModal
        :show.sync="addGroupModal"
        :no-close-on-backdrop="true"
        color="transparent"
        border-color="primary"
        :title="$t('components.addAccountingGroup')"
    >

      <CRow>
        <CCol col="6">
          <CInput
              type="number"
              v-on:keypress="isNumber($event)"
              :label="$t('components.groupCode')"
              v-model="group_code"
          />
          <CInput
              :label="$t('components.groupName')"
              v-model="group_name"
          />
          <CSelect
              :label="$t('components.groupType')"
              v-model="group_type"
              :options="items_types"
          />
          <CSelect
              :label="$t('components.groupNature')"
              :options="items_natures"
              v-model="group_nature"
          />

        </CCol>
      </CRow>
      <template #footer>
        <CButton @click="insert_data()"
                 color="success"
        >{{ $t("buttons.ok") }}
        </CButton>
        <CButton
            @click="addGroupModal = false"
            color="danger"
        >{{ $t("buttons.cancel") }}
        </CButton>
      </template>
    </CModal>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles
import Vue from 'vue'
import TreeTable2 from 'vue-table-with-tree-grid'

Vue.use(TreeTable2)

var items_data = [];


export default {
  name: 'Login',
  components: {
    'test-dynamic': () => import('../documents/PrintDocument'),
    TreeTable2
  },
  data() {

    return {
      addGroupModal: false,
      group_code: '',
      group_name: '',
      group_nature: '',
      group_type: '',
      group_parent: 0,
      items_types: [],
      items_natures: [],
      data2: [],
      data: [],
      columns: [
        {
          label: this.$t('tables.code'),
          prop: 'code',
        },
          {
          label: this.$t('tables.name'),
          prop: 'name',
        },
        {
          label: this.$t('tables.nature'),
          prop: 'nature',
        },
        {
          label: this.$t('tables.type'),
          prop: 'type',
        },
        {
          label: this.$t('tables.status'),
          prop: 'status',
        }, {
          label: this.$t('tables.vatRate'),
          prop: 'vatRate',
        },
        {
          label: this.$t('tables.operation'),
          prop: 'Operation',
          minWidth: '50px',
          type: 'template',
          template: 'operation',
        },
      ],

      props: {
        stripe: false,
        border: true,
        showHeader: true,
        showSummary: false,
        showRowHover: true,
        showIndex: false,
        treeType: true,
        isFold: true,
        expandType: false,
        selectionType: false,
      },

      show_document: 'test-dynamic',
      printed_doc_id: 0,
      name: '',
      file: '',


      start_date: '',
      end_date: '',
      submit_refer: 0,
      refer_person: null,
      selected_template: 0,

      status_form: 0,

    }
  }, mounted() {

    this.$root.root_validate_errors = [];


    this.get_all_docs();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.person_id': function () {
      this.get_all_docs();

    },
    'start_date': function () {
      this.get_all_docs();

    },
    'end_date': function () {
      this.get_all_docs();
    }
  },
  methods: {

    get_all_docs() {
      this.get_lists_groups();
      this.get_lists_natures();
      this.get_lists_types();
      // this.get_lists_pay();

    },
    add_sub_row(item) {
      this.group_parent = item.id;

      this.addGroupModal = true;
    },
    go_to_detailed(item) {

      this.$router.push({path: '/dashboard/accounting/detailed-accounting-groups/' + item.id});

    },

    get_lists_groups() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {
              // self.items_receive = content_data.data.map((item, row_id) => {
              //   return {...item, row_id}
              //
              // });

              response.data.data.forEach((val) => {
                if (val.accNature == 1) {
                  val.nature = self.$t('debtor');
                }
                if (val.accNature == 2) {
                  val.nature = self.$t('creditor');
                }
                if (val.accNature == 3) {
                  val.nature = self.$t('neutral');
                }
                if (val.accNature == 0) {
                  val.nature = '';
                }

                if (val.accType == 1) {
                  val.type = self.$t('permanent');
                }
                if (val.accType == 2) {
                  val.type = self.$t('temporary');
                }
                if (val.accType == 0) {
                  val.type = '';
                }
              });
              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  var obj = {
                    name: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    id: val.id,
                    children: self.get_childrens(val.id, response.data.data)
                  }
                  self.data2.push(obj);
                }

              });

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            name: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode, id: val2.id, children: this.get_childrens(val2.id, list), nature: val2.nature,
            type: val2.type,
          }
          array.push(obj);
          // val2.inserted = true;

        }
      });
      return array;
    },
    get_lists_types() {
      var self = this;

      // GetChequeInfo
      // FirstDate
      // SecondDate
      // MasterId => 0 biad ya por bede
      const formData = new FormData();
      var url = "Get_SysAccountTypes";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_types = [];
          self.items_types = self.sort_array(
                  self.items_types, response.data.data,
                  'accTypeId','accTypeTitle');

          // response.data.data.forEach((val) => {
          //   var obj = {label: val.accTypeTitle, value: val.accTypeId};
          //   self.items_types.push(obj);
          //
          // });
          self.group_type = response.data.data[0].accTypeId

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_lists_natures() {
      var self = this;


      const formData = new FormData();
      var url = "Get_SysAccountNatures";
      // formData.append("MasterId", 0);
      // formData.append("FirstDate", self.start_date);
      // formData.append("SecondDate", self.end_date);

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          self.items_natures = [];
          self.items_natures = self.sort_array(
                  self.items_natures, response.data.data,
                  'accNatureId','accNatureTitle');

          // response.data.data.forEach((val) => {
          //   var obj = {label: val.accNatureTitle, value: val.accNatureId};
          //   self.items_natures.push(obj);
          //
          // });
          self.group_nature = response.data.data[0].accNatureId;
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {
            console.log(error);
          });

    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.group_code != '' && this.group_name != '') {
        return true;
      }


      if (this.group_code == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertCode'));
      }
      if (this.group_name == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }

      return false;
      // e.preventDefault();
    },
    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "Add_AccountingGroup";
      } else {
        url = "Edit_AccountingGroup";
      }
      formData.append('AccountId', this.status_form)

      formData.append('AccountName', this.group_name);
      formData.append('AccountCode', this.group_code);
      formData.append('AccType', this.group_type);
      formData.append('AccNature', this.group_nature);
      formData.append('ParentId', this.group_parent);
      self.addGroupModal = false;

      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {


        self.status_form = 0;
        self.group_parent = 0;
        self.group_name = '';
        self.group_code = '';
        self.get_all_docs();
        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },


  },

}

</script>
<style>
.zk-table__cell-inner {
  text-align: initial;
}
</style>